"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableTextCell = void 0;
var react_1 = __importStar(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var editable_cell_styles_1 = require("./editable_cell.styles");
var global_styles_1 = require("../../Global/global.styles");
var shared_styles_1 = require("./shared.styles");
var PopoverContent = function (props) {
    var updateRow = props.updateRow, closePopover = props.closePopover, originalVal = props.originalVal;
    var _a = (0, react_1.useState)(originalVal), value = _a[0], setValue = _a[1];
    return (react_1.default.createElement(global_styles_1.FlexContainer, null,
        react_1.default.createElement(shared_styles_1.EditElement, null,
            react_1.default.createElement(storm_ui_1.Input, { id: (0, storm_ui_1.useUID)('edit-table-cell-input'), hideLabel: true, label: '', value: value, onChange: function (e) { return setValue(e.target.value); } })),
        react_1.default.createElement(shared_styles_1.EditElement, null,
            react_1.default.createElement(storm_ui_1.Button, { primary: true, onClick: function () {
                    updateRow(value);
                    closePopover();
                }, disabled: value === originalVal || !value }, "Save")),
        react_1.default.createElement(shared_styles_1.EditElement, null,
            react_1.default.createElement(shared_styles_1.CancelButton, { onClick: closePopover }, "Cancel"))));
};
var EditableTextCell = /** @class */ (function (_super) {
    __extends(EditableTextCell, _super);
    function EditableTextCell(props) {
        var _this = _super.call(this, props) || this;
        _this.buttonRef = (0, react_1.createRef)();
        _this.state = { isPopoverOpen: false, updateSucceeded: false, updateFailed: false };
        return _this;
    }
    EditableTextCell.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storm_ui_1.Popover, { isOpen: this.state.isPopoverOpen, anchorEl: this.buttonRef.current ? this.buttonRef.current : undefined, offset: { x: -10, y: -10 }, withBackdrop: true, onClose: function () { return _this.setState({ isPopoverOpen: false }); } },
                react_1.default.createElement(PopoverContent, { updateRow: function (newVal) {
                        if (_this.props.updateRow) {
                            _this.props.updateRow(_this.props.row, _this.props.column.id, newVal);
                            _this.setState({ updateSucceeded: true });
                        }
                    }, closePopover: function () { return _this.setState({ isPopoverOpen: false }); }, originalVal: this.props.cell.value })),
            react_1.default.createElement(global_styles_1.FlexContainer, { ref: this.buttonRef },
                react_1.default.createElement(shared_styles_1.ClickableCell, { onClick: function () { return _this.setState({ isPopoverOpen: true }); } },
                    react_1.default.createElement(shared_styles_1.EllipsisText, null, this.props.cell.value),
                    react_1.default.createElement(editable_cell_styles_1.EditIcon, { icon: { prefix: 'fas', iconName: 'edit' }, size: "1x", fixedWidth: false })),
                this.state.updateSucceeded && react_1.default.createElement(editable_cell_styles_1.SuccessIcon, { icon: { prefix: 'fas', iconName: 'check' }, size: '1x', fixedWidth: true, "data-testid": 'success-icon' }))));
    };
    return EditableTextCell;
}(react_1.Component));
exports.EditableTextCell = EditableTextCell;
